// extracted by mini-css-extract-plugin
var _1 = "arrow-wrapper__GIT1x";
var _2 = "input__C8uAU";
export { _1 as "arrowWrapper", _2 as "input" }
